import { Fill, Text } from 'ol/style';
import Style from 'ol/style/Style';
import {
  FontName,
  FontStyle,
  FontWeight,
  HorizontalAlign,
} from '@/components/Map/MapViewer/MapViewer.types';
import { getFontName } from '@/components/Map/MapViewer/utils/mapElementsRendering/text/getFontName';

export default function getTextStyle({
  text,
  fontSize,
  color,
  zIndex,
  horizontalAlign,
  fontNameEnum,
  fontStyleEnum,
  fontWeightEnum,
  overflow = true,
}: {
  text: string;
  fontSize: number;
  fontNameEnum: FontName;
  fontStyleEnum: FontStyle;
  fontWeightEnum: FontWeight;
  color: string;
  zIndex: number;
  horizontalAlign: HorizontalAlign;
  overflow?: boolean;
}): Style {
  const fontName = getFontName(fontNameEnum);
  const fontStyle = fontStyleEnum === 'ITALIC' ? 'italic ' : '';
  const fontWeight = fontWeightEnum === 'BOLD' ? 'bold ' : '';
  return new Style({
    text: new Text({
      text,
      font: `${fontStyle}${fontWeight}${fontSize}pt ${fontName}`,
      fill: new Fill({
        color,
      }),
      placement: 'point',
      textAlign: horizontalAlign.toLowerCase() as CanvasTextAlign,
      textBaseline: 'middle',
      overflow,
    }),
    zIndex,
  });
}
